"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.devicesCommon_en_us = void 0;
function devicesCommon_en_us() {
    return {
        "devices.errors.nodevicefoundforpin": "No device found for this Code",
        "devices.errors.user.user_not_found": "User not found",
        "devices.errors.user.email_already_exists": "User already exists",
        "devices.errors.user.invalid_password": "Wrong password",
        "devices.pairing.message": "Pair your Browser, TV or tablet",
        "devices.pairing.submessage": "After you have paired your device with the Backoffice, you can conveniently push new content on your device from there.",
        "devices.pairing.firststep": "Please open ${devicesUrl} on another device. Alternatively you can open the Backoffice, navigate to your desired project and open the devices module. If the devices module is not visible, then open it via Project Settings > Navigation",
        "devices.pairing.entercode": "Add a new device and use the following code",
        "devices.pairing.generatecode": "Generating pairing code...",
        "devices.pairing.successfullypaired": "Device successfully paired",
        "devices.pairing.nocontent": "You can now start to push content to this device via the Backoffice"
    };
}
exports.devicesCommon_en_us = devicesCommon_en_us;
